module.exports = __webpack_public_path__ + "static/img/plan-task_02.a3f48d0b.png";